
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/pvc/windows/aluplast",
      function () {
        return require("private-next-pages/pvc/windows/aluplast/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/pvc/windows/aluplast"])
      });
    }
  